/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Card,
  CardBody,
  ButtonGroup,
  Button,
  Flex,
  Heading,
  Text,
  OrderedList,
  ListItem
} from '@chakra-ui/react'
import React, { Children, useState } from 'react'

import NoteLink from '../../components/NoteLink'

interface ClientPostItData {
  children: React.ReactNode
}

const ClientPostIt: React.FC<ClientPostItData> = (props) => {
  const cardStyles = {
    bg: 'yellow.300',
    boxShadow: 'sm',
    transition: 'all 200ms ease',
    height: '100%',
    borderRadius: 0,
    '.bend': {
      position: 'absolute',
      bg: 'white',
      bottom: '0px',
      right: '0px',
      borderStyle: 'solid',
      h: 'auto',
      aspectRatio: '1/1',
      w: '15%',
      boxShadow: '0px 2px 0px 0px white, 2px 0px 0px 0px white',
      transition: 'all 0.5s',
      zIndex: 2,
      overflow: 'hidden',
      '&:after': {
        pointerEvents: 'none',
        color: 'yellow.100',
        background:
          'linear-gradient(135deg, currentcolor calc(50% - 1px), rgba(232,232,232,1) 50%, rgba(255,255,255,0) 50.2%, rgba(255,255,255,0) 100%)',
        content: '""',
        display: 'block',
        pos: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      button: {
        pos: 'absolute',
        right: '20px',
        bottom: '20px'
      }
    },
    '&:hover': {
      transitionDelay: '.1s'
    },
    '&:hover .bend': {
      w: { base: '17%', md: '17%' }
    },
    '.chakra-card__body': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }
  }

  return (
    <Card sx={cardStyles}>
      <CardBody aspectRatio={1.1} pos="relative">
        {props.children}
      </CardBody>
      <Box className="bend" />
    </Card>
  )
}

const Page: React.FC = (data) => {
  return (
    <Flex sx={{ ...styles.container, ...styles.joinRoom }} p="20px">
      <Flex
        gap="16px"
        mt="20px"
        py="20px"
        flexDir="column"
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box w="100%" maxW={'1200px'}>
          <Box p="0 50px 50px">
            <Heading w="100%" textAlign="center" mb="0">
              Video Armageddon {"'"}89
            </Heading>

            <Text textAlign="center">
              Race Super Mario Bros. 3 with up to 89 players in real time.
              <br />
              <sub>
                <em>
                  (You will need to supply your own {'"'}Super Mario Bros. 3
                  {'" '}PRG1 ROM)
                </em>
              </sub>
            </Text>
            <Box
              w="100%"
              h="auto"
              maxW={'1200px'}
              display="block"
              mx="auto"
              as="iframe"
              aspectRatio={560 / 315}
              src="https://www.youtube.com/embed/9akLWRGkoqY?si=j-hAdTDeEQtFpfd8"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </Box>
        </Box>
      </Flex>
      <Flex gap="16px" mt="20px">
        <Box flex="1">
          <ClientPostIt>
            <Box>
              <Heading fontSize="24px" textAlign="left">
                Setup:
              </Heading>
              <OrderedList>
                <Text
                  as={ListItem}
                  fontSize="18px"
                  lineHeight={1.4}
                  textAlign="left"
                >
                  <Button
                    as="a"
                    variant="outlineNegative"
                    href="https://github.com/Reactvts/BizHawk/releases"
                    target="_blank"
                    mb="5px"
                  >
                    Download BizHawk with Web Socket Support version 2.9.1.6
                  </Button>{' '}
                  <br />
                  This is a custom Emulator that supports connecting
                  to&nbsp;Reactvts.
                </Text>
                <Text
                  as={ListItem}
                  fontSize="18px"
                  lineHeight={1.4}
                  textAlign="left"
                >
                  Unzip the file anywhere you like.
                  <br />
                  <em>(example: C:\Desktop\Bizhawk)</em>
                </Text>
                <Text
                  as={ListItem}
                  fontSize="18px"
                  lineHeight={1.4}
                  textAlign="left"
                >
                  Put the Mario Bros. 3 PRG1 Rom in the Reactvts Roms Folder
                  <br />
                  (example: c:\Desktop\Bizhawk\Reactvts\Roms\Mario3.nes)
                  <br />
                  <em>
                    The filename is no longer important, it will find any valid
                    Mario 3 PRG1 rom
                  </em>
                  <br />
                  <br />
                  <strong>
                    {' '}
                    Do not load the rom yet, it&apos;ll load automatically when
                    you join a room.
                  </strong>
                </Text>
                <Text
                  as={ListItem}
                  fontSize="18px"
                  lineHeight={1.4}
                  textAlign="left"
                >
                  On Windows, run &quot;Reactvts.bat&quot; from the root Bizhawk
                  folder.
                  <br />
                  On Linux, open the &quot;reactvts.lua&quot; in the
                  Bizhawk/Reactvts folder using the lua console in Bizhawk.
                  <br />
                </Text>
                <Text
                  as={ListItem}
                  fontSize="18px"
                  lineHeight={1.4}
                  textAlign="left"
                >
                  If everything is working correctly, you will get a window
                  prompt that says &quot;Reactvts&quot; and it should have a
                  Name and Room Code Field.
                </Text>
                <Text
                  as={ListItem}
                  fontSize="18px"
                  lineHeight={1.4}
                  textAlign="left"
                >
                  Enter Name and Room Code and the game should load
                  automatically. Leave the window open while you play. If you
                  close it you will lose connection to the room. Also you can
                  see your status in the log window.
                  <br />
                  <br />
                  <strong>
                    Hosting a Race? Don&apos;t have Video Armageddon running
                    yet?
                  </strong>{' '}
                  <br />
                  <Button
                    as="a"
                    variant="outlineNegative"
                    href="/video-armageddon"
                    target="_blank"
                  >
                    Click Here to start a room
                  </Button>
                </Text>
              </OrderedList>
            </Box>
            <Flex justifyContent="center" w="100%">
              <Button
                as="a"
                variant="outlineNegative"
                href="https://github.com/Reactvts/BizHawk/releases"
                target="_blank"
              >
                Download And Instructions
              </Button>
            </Flex>
          </ClientPostIt>
        </Box>
        <Box flex="1">
          <ClientPostIt>
            <Box>
              <Heading fontSize="24px" textAlign="left">
                Instructions:
              </Heading>
              <Text fontSize="16px" lineHeight={1.4} textAlign="left">
                Race to get the highest score in the set time limit. Everyone
                will start at World 1-1 and play until time runs out. Coins
                collected in game can be used to purchase &quot;Mario Kart&quot;
                style items.
              </Text>
              <Heading fontSize="24px" textAlign="left">
                Items: (Only available in &quot;89&quot; Mode)
              </Heading>
              <Text fontSize="16px">
                Hit Select on your controller to purchase items for 10 in-game
                coings. Hit select again to fire the item.
              </Text>
              <Text fontSize="16px">
                <Box as="strong" fontSize="18px">
                  Green Shells
                </Box>
                <br />
                Green Shells will hit players ahead of you losing any power-ups
                they&apos;ve collected. If you&apos;re already small, you just
                get stunned for a moment.{' '}
              </Text>

              <Text fontSize="16px">
                You can dodge Green shells by jumping just as they are about to
                hit. If you do dodge the shell, it will continue to the player
                ahead of you.{' '}
              </Text>

              <Text fontSize="16px">
                <Box as="strong" fontSize="18px">
                  Red Shells
                </Box>
                <br />
                Red Shells act like Green Shells but they cannot be dodged.{' '}
              </Text>

              <Text fontSize="16px">
                <Box as="strong" fontSize="18px">
                  Bananas
                </Box>
                <br />
                Bananas will temporarily stun players behind you. They can also
                be fired when a shell is about to hit to knock them out. You can
                also jump over bananas the same as green shells, and they will
                continue to the power behind you.{' '}
              </Text>

              <Text fontSize="16px">
                Bananas and Shells cannot affect you in the Overworld or any
                other time the in-game timer is frozen. (After beating a boss,
                mushroom house, etc)
              </Text>

              <Text fontSize="16px">
                <Box as="strong" fontSize="18px">
                  Mushrooms
                </Box>
                <br />
                Get a 50% speed boost in the game (but be careful, it&apos;s not
                just Mario, the whole game is running 50% faster)
              </Text>

              <Text fontSize="16px" paddingRight="120px">
                <Box as="strong" fontSize="18px">
                  Lightning
                </Box>
                <br />
                Make all the other players lose their currently held items and
                slow them down for a short time.
              </Text>

              <Text fontSize="16px" paddingRight="120px">
                <Box as="strong" fontSize="18px">
                  Star
                </Box>
                <br />
                Give yourself an in-game Star power-up, which makes you
                invincible to in-game enemies AND player-thrown items.
              </Text>
            </Box>
          </ClientPostIt>
        </Box>
      </Flex>
    </Flex>
  )
}

const styles = {
  container: {
    maxW: { base: 'calc(100%)', md: '1600px' },
    p: '20px',
    mx: { base: 'auto', md: 'auto' },
    flex: 1,
    backgroundColor: '#fff',
    justifyContent: 'center',
    flexDir: 'column',
    minHeight: 'calc(100dvh - 59px)',
    maxHeight: '-webkit-fill-available',
    label: {
      mr: '0',
      mb: '12px',
      fontSize: '18px',
      fontWeight: 'bold'
    }
  },
  joinRoom: {
    input: {
      // textTransform: 'uppercase'
    }
  }
}

export { Page }
